"use client";

import { useState } from "react";
import { toast } from "sonner";
import styles from "styles/components/newsletter-section.module.css";
import { Mail, Send } from "lucide-react";
import base from "lib/base";

const NewsletterSection = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("И-мэйл хаягаа оруулна уу");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${base.apiUrl}/email-subscriptions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, source: "gerelt_front" }),
      });
      const data = await res.json();
      if (!res.ok || data?.success === false) {
        throw new Error(data?.message || "Алдаа гарлаа");
      }
      setEmail("");
      toast.success("Амжилттай бүртгэгдлээ");
    } catch (error) {
      toast.error(error?.message || "Алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={styles.section}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 mb-3 mb-md-0">
            <h3 className={styles.title}>Мэдээлэл авах</h3>
            <p className={styles.subtitle}>
              Шинэ ном, хямдралын мэдээллийг хамгийн түрүүнд хүлээн аваарай
            </p>
          </div>
          <div className="col-md-6">
            <form className={styles.formContainer} onSubmit={handleSubmit}>
              <div className={styles.inputWrapper}>
                <Mail className={styles.inputIcon} />
                <input
                  type="email"
                  placeholder="И-мэйл хаягаа оруулна уу"
                  className={styles.input}
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <button
                type="submit"
                className={styles.submitBtn}
                disabled={loading}
              >
                <Send className={styles.btnIcon} />
                {loading ? "Илгээж байна..." : "Илгээх"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
